import { IconShield } from '@leland-dev/leland-ui-library';
import React from 'react';

import { SITE_URL } from '../../utils/constants';

import InfoWithIcon from './InfoWithIcon';

type Props = Pick<
  React.ComponentPropsWithoutRef<typeof InfoWithIcon>,
  'className'
>;

const LelandExperienceGuarantee: React.FC<Props> = (props) => (
  <InfoWithIcon
    {...props}
    small
    Icon={IconShield}
    text={
      <>
        Protected by the{' '}
        <a
          href={`${SITE_URL}/legal/experience-guarantee`}
          className="link underline"
          target="_blank"
          rel="noopener noreferrer"
          id="leland_experience_guarantee--view_guarantee"
        >
          Leland Experience Guarantee
        </a>
      </>
    }
  />
);

export default LelandExperienceGuarantee;
